import React from "react";
import {
  useNavigate,
  useParams,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Box, Stack } from "@mantine/core";
import { useClient } from "../../context/ClientContext";
import BrandedLoadingOverlay from "../common/BrandedLoadingOverlay/BrandedLoadingOverlay";
import PageHeaderBar from "../common/PageHeaderBar";
import ClientDetails, { ClientDetailTab } from "./ClientDetails";
import styles from "./ClientDetailPage.module.css";

/**
 * Full-page client profile (tabbed). List view links here at /admin/clients/:clientId.
 */
export default function ClientDetailPage() {
  const { clientId } = useParams<{ clientId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { clientsById, loading } = useClient();

  // Deep links (e.g. the package_purchased notification) may request a
  // specific tab via router state; default to overview otherwise.
  const initialTab = (location.state as { targetTab?: ClientDetailTab } | null)
    ?.targetTab;

  const client = clientId ? clientsById[clientId] : undefined;

  if (loading && !client) {
    return (
      <Box className={styles.page}>
        <BrandedLoadingOverlay visible background="transparent" />
      </Box>
    );
  }

  if (!client) {
    return <Navigate to="/admin/clients" replace />;
  }

  return (
    <Box className={styles.page}>
      <PageHeaderBar label="All Clients" to="/admin/clients" />
      <Stack gap="lg" className={styles.inner}>
        <ClientDetails
          client={client}
          onClose={() => navigate("/admin/clients")}
          initialTab={initialTab}
        />
      </Stack>
    </Box>
  );
}
